import React from "react";
import "./App.css";
import RoutesApp from "./routes"

//Slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function App(){
  return(
    <RoutesApp/>
  )
}